import { Store, useStore } from '@tanstack/react-store';

export const DEFAULT_LAYOUT: Layout = 'grid';

export type Layout = 'grid' | 'list';

type LayoutStore = {
    layout: Layout;
};

const store = new Store<LayoutStore>({
    layout: DEFAULT_LAYOUT,
});

function setLayout(layout: Layout) {
    store.setState((state) => {
        return {
            ...state,
            layout,
        };
    });
}

export function useLayout() {
    const layout = useStore(store, (state) => state.layout);

    return { layout, setLayout };
}
